import { george, pr, theme, ui } from "aaa";
import { observer } from "mobx-react";
import { themeColors } from "muiTheme";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { CancelButton } from "../components/CancelButton";
import { ContinueButton } from "../components/ContinueButton";
import { ScreenWithBottomAction } from "../components/ScreenWithBottomAction";
import { JuniorRoutes } from "../JuniorRoutes";
import { JuniorStore } from "../JuniorStore";

const TIMER_SECONDS = 30;

function formatTimer(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

function toDataUrl(base64: string): string {
    if (base64.startsWith("data:")) {
        return base64;
    }
    return `data:image/png;base64,${base64}`;
}

type IProps = { store: JuniorStore };

export const JuniorActivationScanCode = observer(({ store }: IProps) => {
    const handleClose = () => {
        pushRoute(JuniorRoutes.DETAIL);
    };

    const [secondsLeft, setSecondsLeft] = React.useState(TIMER_SECONDS);

    const loadActivationCode = async () => {
        await store.loadJuniorActivationCode();
    };

    React.useEffect(() => {
        loadActivationCode();
    }, [store]);

    React.useEffect(() => {
        if (secondsLeft <= 0) return;
        const id = window.setInterval(() => {
            setSecondsLeft((prev) => (prev <= 0 ? 0 : prev - 1));
        }, 1000);
        return () => clearInterval(id);
    }, [secondsLeft]);

    const refreshCode = () => {
        setSecondsLeft(TIMER_SECONDS);
        store.loadJuniorActivationCode();
    };

    return (
        <ScreenWithBottomAction
            title={ui.__("gJunior.activation.scan.title")}
            ContinueButton={<ContinueButton
                messageId="gJunior.activation.scan.doneButton"
                onClick={() => { }}
            />}
            CancelButton={<CancelButton onClick={handleClose} />}
        >
            <pr.P_16_CONTENT style={{
                paddingLeft: theme.MARGIN_SMALL,
                paddingRight: theme.MARGIN_SMALL,
                marginTop: theme.MARGIN_SMALL,
            }}>
                {ui.__("gJunior.activation.scan.description")}
            </pr.P_16_CONTENT>

            <pr.P_14_TITLE style={{
                fontWeight: 600,
                marginLeft: theme.MARGIN_SMALL,
                marginRight: theme.MARGIN_SMALL,
                marginTop: theme.MARGIN_LARGE,
            }}>
                {ui.__("gJunior.activation.scan.activationCodeLabel")}
            </pr.P_14_TITLE>

            <george.Card
                elevated={false}
                style={{
                    borderRadius: theme.BORDER_RADIUS_LARGE,
                    padding: theme.MARGIN,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {secondsLeft <= 0 ? (
                    <div
                        role="button"
                        tabIndex={0}
                        onClick={refreshCode}
                        onKeyDown={(e) => e.key === "Enter" && refreshCode()}
                        style={{
                            padding: theme.MARGIN,
                            textAlign: "center",
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <img
                            src={require("../../../assets/gJunior/stop_timer.svg")}
                            alt=""
                            style={{
                                width: 150,
                                height: 150,
                                display: "block",
                                marginBottom: theme.MARGIN,
                            }}
                        />
                        <pr.P_18_TITLE
                            style={{
                                fontWeight: 700,
                                textAlign: "center",
                                lineHeight: "24px",
                                marginBottom: theme.MARGIN_SMALL,
                            }}
                        >
                            {ui.__("gJunior.activation.scan.timerExpired.sorry")}
                        </pr.P_18_TITLE>
                        <pr.P_16_CONTENT
                            style={{
                                textAlign: "center",
                                lineHeight: "22px",
                                marginBottom: theme.MARGIN_SMALL,
                            }}
                        >
                            {ui.__("gJunior.activation.scan.timerExpired.expired")}
                            <br />
                            {ui.__("gJunior.activation.scan.timerExpired.tapForNew")}
                        </pr.P_16_CONTENT>

                    </div>
                ) : (
                    <>
                        <pr.P_14_CONTENT style={{
                            color: ui.isDarkMode ? "white" : themeColors.georgeBlue,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 4,
                            padding: "6px 10px",
                            borderRadius: 16,
                            marginBottom: theme.MARGIN,
                            marginTop: theme.MARGIN,
                            fontWeight: 600,
                        }}>
                            <img src={require("../../../assets/gJunior/clock_icon.svg")}
                                style={{
                                    width: 20,
                                    height: 20,
                                    color: themeColors.georgeBlue,
                                    marginRight: 4,
                                }}
                            />
                            {formatTimer(secondsLeft)}
                        </pr.P_14_CONTENT>

                        {store.activationCodeResponse?.challengeImage && (
                            <img
                                src={toDataUrl(store.activationCodeResponse.challengeImage)}
                                alt=""
                                style={{
                                    width: 160,
                                    height: 160,
                                    display: "block",
                                }}
                            />
                        )}
                    </>
                )}
            </george.Card>
        </ScreenWithBottomAction>
    );
});



// WEBPACK FOOTER //
// ./src/components/gJunior/activationStep/JuniorActivationScanCode.tsx